module.exports = __webpack_public_path__ + "img/FullRedCol1.db1f6558.jpg";